export { default as useInitialData } from './useInitialData';
